<template minapp='mpx' xlang='wxml'>
  <view class="container">
    <view class="schedule-item" catchtap="goDetail" wx:class="{{{'schedule-item-nopay': !isPay}}}">
      <view class="status">
        <view class="status-icon" wx:if="{{title.showIcon}}"></view>
        <view class="status-icon-inner" wx:if="{{title.showIcon}}"></view>
        <view class="status-title" wx:class="{{{'status-highlight': title.highlight}}}">{{
          title.text
        }}</view>
        <view class="pay" wx:if="{{!isPay}}">
          <view class="pay-left">
            <view class="pay-amount">{{ payFee }}</view>
            <view wx:style="{{ {color: '#FF6400'} }}">元</view></view
          >
          <view class="pay-right">
            <view class="pay-count" wx:if="{{timeLeft}}">剩余{{ timeLeft }}</view>
            <view class="pay-button">立即支付</view>
          </view>
        </view>
        <view class="tips" wx:elif="{{booked}}">{{ tips }}</view>
        <view wx:else class="scramble">
          <view class="scramble-code">{{ alternativeTrainCodes }}</view>
          <view class="scramble-gap"></view>
          <view class="scramble-date">{{ alternativeStartDate }}</view>
        </view>
      </view>
      <view class="gap" wx:class="{{{'gap-nopay': !isPay}}}"></view>
      <view class="train-info" wx:style="{{trainInfoStyle}}">
        <view
          class="train-info-icon"
          wx:if="{{booked}}"
          wx:style="{{unionJourney?'flex-shrink:0':''}}"
        ></view>
        <view
          class="train-info-code"
          wx:if="{{booked}}"
          wx:style="{{unionJourney?'margin-right:6px;flex-shrink:0':''}}"
          >{{ unionJourney ? transferCityName + '转' : code }}</view
        >
        <view class="station-container">
          {{ fromInfo }}
          <es-icon name="arrow-switch-right" color="#666666" class="train-info-arrow" />
          <view class="train-info-end-container">
            <text wx:if="{{booked}}" class="train-info-end">
              <text>{{ arriveTime }}</text>
              <text class="train-info-daydiff">{{ dayDifference }}</text>
              <text class="train-info-end-station">{{ toStation }}</text>
            </text>
            <text wx:else>{{ toStation }}</text>
          </view>
        </view>
      </view>
      <view class="info-card" wx:if="{{booked && !unionJourney}}">
        <view class="seat-info">
          <view class="seat-info-window">
            检票口
            <view
              class="seat-info-highlight"
              wx:class="{{{'window': hasCheckEntrance}}}"
              wx:if="{{window}}"
              >{{ window }}</view
            >
            <view class="seat-info-highlight" wx:else>详见车站大屏</view>
          </view>
          <view class="seat-info-gap"></view>
          <view class="seat-info-code">
            <view class="seat-info-code-title"
              >座次号<view wx:if="{{showMoreBtn}}" class="seat-info-more">全部</view></view
            >
            <view class="seat-info-highlight seat">{{ seatName }}</view>
          </view>
        </view>
      </view>
      <view wx:if="{{booked && unionJourney}}" class="transfer-info-box">
        <!-- <view wx:if="{{booked }}" class="transfer-info-box"> -->
        <view class="info-card" wx:style="{{isSingleOrder?'width:30vw':'margin-right:10px'}}">
          <view class="seat-info">
            <view class="seat-info-window">
              1程{{ firstSegmentInfos || '' }}
              <view class="seat-info-highlight" wx:class="{{{'window': hasCheckEntrance}}}">{{
                firstSeatStatus
              }}</view>
            </view>
          </view>
        </view>
        <view class="info-card" wx:style="{{isSingleOrder?'width:30vw':'margin-left:10px'}}">
          <view class="seat-info">
            <view class="seat-info-window">
              2程{{ secondSegmentInfos || '' }}
              <view class="seat-info-highlight" wx:class="{{{'window': hasCheckEntrance}}}">{{
                secondSeatStatus
              }}</view>
            </view>
          </view>
        </view>
      </view>
      <view class="scramble-tips" wx:if="{{!booked}}">
        <view class="scramble-tips-text">
          <!-- <text
            wx:for="{{tips}}"
            class="scramble-tips-text"
            wx:class="{{{'scramble-tips-highlight': index === 1}}}"
            >{{ item }}</text
          > -->
          <hl-text color="#2F497D" hlColor="#338FFF" text="{{tips}}" />
        </view>
        <view class="scramble-tips-gap"></view>
        <view
          >抢票成功率<text class="scramble-tips-rate">{{ successRate }}</text></view
        >
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import { trackEvent } from '@/common/track'
  import dayjs from 'dayjs'

  createComponent({
    props: {
      homeOrderItem: {
        type: Object,
        value: {}
      },
      showNext: {
        type: Boolean,
        value: false
      },
      isSingleOrder: {
        type: Boolean,
        value: false
      }
    },
    data: {
      showMoreBtn: false,
      timer: null,
      timeLeft: ''
    },
    pageLifetimes: {
      hide: function () {
        this.timeLeft = ''
        this.timer && clearTimeout(this.timer)
      }
    },
    computed: {
      status() {
        // 2已占座、21占座中 9 抢票中 4已出票
        return this.homeOrderItem.status
      },
      isPay() {
        // 0待支付，1已支付
        return this.homeOrderItem.is_pay
      },
      title() {
        let title = {}
        if (!this.isPay) {
          title.text = '待支付'
        } else if (this.status === 4) {
          title.text = this.homeOrderItem.approaching_departure_desc || this.homeOrderItem.status_name
          title.highlight =
            this.homeOrderItem.approaching_departure_desc &&
            this.homeOrderItem.approaching_departure_desc !== '待出行'
              ? true
              : false
        } else {
          title.text = this.homeOrderItem.status_name
          title.showIcon = this.homeOrderItem.status_name === '抢票中'
        }
        return title
      },
      tips() {
        let tips = this.homeOrderItem.tips
        if (tips.includes('{')) {
          const left = tips.indexOf('{')
          tips = tips.substring(0, left) + '{' + tips.substring(left)
          const right = tips.indexOf('}')
          tips = tips.substring(0, right) + '}' + tips.substring(right)
        }
        return tips
      },
      successRate() {
        return this.homeOrderItem.success_rate_desc || '暂无'
      },
      code() {
        return this.homeOrderItem.train_code
      },
      fromInfo() {
        const time = dayjs(this.homeOrderItem.start_time)
        const startTime =
          ('0' + time.hour()).slice(-2) + ':' + ('0' + time.minute()).slice(-2)
        return this.booked
          ? startTime + ' ' + this.homeOrderItem.from_station_name
          : this.homeOrderItem.from_station_name
      },
      arriveTime() {
        const time = dayjs(this.homeOrderItem.arrive_time)
        return ('0' + time.hour()).slice(-2) + ':' + ('0' + time.minute()).slice(-2)
      },
      toStation() {
        return this.homeOrderItem.to_station_name
      },
      dayDifference() {
        return this.homeOrderItem.day_difference ? '+' + this.homeOrderItem.day_difference + '天' : ''
      },
      hasCheckEntrance() {
        return (
          this.homeOrderItem.ticket_list?.length &&
          this.homeOrderItem.ticket_list.some((item) => {
            item.has_check_entrance
          })
        )
      },
      window() {
        const set = new Set()
        this.homeOrderItem.ticket_list?.length &&
          this.homeOrderItem.ticket_list.forEach((item) => {
            set.add(item.check_in)
          })
        return [...set].join('、')
      },
      seatName() {
        const set = new Set()
        this.homeOrderItem.ticket_list?.length &&
          this.homeOrderItem.ticket_list.forEach((item) => {
            const name = item.coach_name + item.seat_name
            set.add(name)
          })
        const arr = [...set]
        this.showMoreBtn = arr.length >= 3
        return arr.join('、')
      },
      booked() {
        // 已购票、待支付：true
        // 预约中、抢票中：false
        return !(Number(this.status) === 9)
      },
      trainInfoStyle() {
        return this.booked ? {} : { fontWeight: 500 }
      },
      payFee() {
        return this.homeOrderItem.person_money / 100
      },
      alternativeTrainCodes() {
        return this.homeOrderItem.alternative_train_codes?.join('、')
      },
      alternativeStartDate() {
        return this.homeOrderItem.alternative_start_date?.join('、')
      },
      consultTime() {
        return this.homeOrderItem.consult_time
      },
      unionJourney() {
        // 是否联程
        return this.homeOrderItem.union_journey === 1 && this.homeOrderItem.status !== 4
      },
      firstSegmentInfos() {
        let code = ''
        this.homeOrderItem.ticket_list?.length &&
          this.homeOrderItem.ticket_list.forEach((item) => {
            if (item.union_segment_index == 1) {
              code = item.train_code
            }
          })
        return code
      },
      secondSegmentInfos() {
        let code = ''
        this.homeOrderItem.ticket_list?.length &&
          this.homeOrderItem.ticket_list.forEach((item) => {
            if (item.union_segment_index == 2) {
              code = item.train_code
            }
          })
        return code
      },
      transferCityName() {
        return this.homeOrderItem.transfer_city_name
      },
      firstSeatStatus() {
        const set = new Set()
        this.homeOrderItem.ticket_list?.length &&
          this.homeOrderItem.ticket_list.forEach((item) => {
            if (item.union_segment_index == 1) {
              const name = item.coach_name + item.seat_name
              set.add(name)
            }
          })
        const arr = [...set]
        this.showMoreBtn = arr.length >= 3
        return arr.join('、')
      },
      secondSeatStatus() {
        const set = new Set()
        this.homeOrderItem.ticket_list?.length &&
          this.homeOrderItem.ticket_list.forEach((item) => {
            if (item.union_segment_index == 2) {
              const name = item.coach_name + item.seat_name
              set.add(name)
            }
          })
        const arr = [...set]
        this.showMoreBtn = arr.length >= 3
        return arr.join('、')
      }
    },
    methods: {
      goDetail() {
        trackEvent('userteam_train_home_ordercard_ck', 'UT-火车票-首页-订单卡片-点击', {
          type: this.homeOrderItem.approaching_departure_desc || this.homeOrderItem.status_name || ''
        })
        const { id = '', pre_order_id = '' } = this.homeOrderItem
        innerRouter.push(pagePath().ORDERDETAIL, { order_id: pre_order_id || id })
      },
      updateEndTime(time) {
        if (time < 0) {
          setTimeout(() => {
            this.triggerEvent('refresh')
          }, 1000)
          return
        }
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        const min = Math.floor(time / 60)
        const sec = '0' + (time - min * 60)
        this.timeLeft = min + ':' + sec.slice(-2)
        this.timer = setTimeout(() => this.updateEndTime(--time), 1000)
      }
    },
    watch: {
      consultTime: {
        handler(val) {
          if (val) {
            this.updateEndTime(val)
          }
        },
        immediate: true
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .container
    display flex
    width 100%
  .schedule-item
    background #EAF3FF
    height fit-content
    border-radius 20px
    border 2px solid #FFFFFF
    padding 16px 16px 14px 16px
    font-family PingFang SC
    position relative
    font-size 12px
    width 100%
    // flex-shrink 0
    &::before
      content ''
      position absolute
      background url('https://dpubstatic.udache.com/static/dpubimg/273XDA_e4b022OkzrIO__.png')
      width 94px
      height 33px
      top 9.5px
      right 10.6px
      background-size cover
      background-repeat no-repeat
    &-nopay
      padding 12px 16px 14px 16px
    .status
      font-size 20px
      line-height 20px
      font-weight 500
      display flex
      align-items center
      position relative
      &-title
        min-width 60px
      &-icon
        width 24px
        height 24px
        margin-right 4px
        background url('https://dpubstatic.udache.com/static/dpubimg/sczyu52pU-WsvMf5Rwb_w.png')
        background-size cover
        background-repeat no-repeat
        margin-top -2px
        transfrom-origin center center
        transform rotate(45deg)
        animation-name test
        animation-duration 1s
        animation-iteration-count infinite
        @keyframes test
          0%
            transform rotate(0)
          100%
            transform rotate(360deg)
      &-icon-inner
        background url('https://dpubstatic.udache.com/static/dpubimg/kPqlmn8yE07krfP-OzG7x.png')
        width 6.775px
        height 7.975px
        background-size cover
        position absolute
        top 6px
        left 8.5px
      &-highlight
        color #338FFF
      .scramble
        display flex
        font-size 12px
        margin-left 10px
        color #666666
        align-items center
        &-code
          max-width 78.5px
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
        &-gap
          height 12px
          background #2F497D
          margin 0 8px
          width 0.5px
          opacity 0.1
        &-date
          max-width 118px
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
    .tips
      font-size 12px
      color #666666
      margin-left 8px
    .gap
      height 0.5px
      background #2F497D
      margin 14px 2px
      opacity 0.1
      &-nopay
        margin 12px 2px
    .train-info
      font-size 16px
      color #222222
      display flex
      align-items center
      &-icon
        background url('https://dpubstatic.udache.com/static/dpubimg/8y48h51kW3QsS8l543qNi.png')
        background-size cover
        width 15px
        height 15px
      &-code
        font-family PingFang HK
        font-weight 500
        margin-right 14px
        margin-left 6.75px
        display inline-block
      &-arrow
        margin 0 8px
      &-end-container
        flex 1
        overflow hidden
      &-end
        display flex
        &-station
          white-space nowrap
          text-overflow ellipsis
          overflow hidden
      &-daydiff
        font-size 10px
        margin-right 4px
    .station-container
      max-width 235px
      display flex
      align-items center
    .info-card
      margin-top 12px
      background #D2E6FF
      padding 14px 14px 12px 14px
      border-radius 10px
      font-size 12px
      color #2F497D
    .seat-info
      display flex
      &-window
        display flex
        flex-direction column
        width 104px
      &-gap
        background #2F497D
        width 0.5px
        margin-right 14px
        padding -1px 0
        opacity 0.1
      &-code
        display flex
        flex-direction column
        &-title
          display flex
          justify-content space-between
          align-items center
      &-more
        position relative
        margin-right 10px
        &::after
          content ''
          position absolute
          background url('https://dpubstatic.udache.com/static/dpubimg/1uNQRIzZfGIb_5I8_oi-i.png')
          background-size cover
          width 10px
          height 10px
          top 3px
          right -10px
      &-highlight
        color #222222
        font-size 15px
        font-weight 500
        margin-top 4px
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      .window
        max-width 96px
        font-size 18px
      .seat
        max-width 160px
        margin-top 4px
    .transfer-info-box
      display flex
      justify-content space-around
    .scramble-tips
      display flex
      flex-direction column
      margin-top 11px
      background #D2E6FF
      padding 8px 14px 8px 14px
      border-radius 10px
      font-size 12px
      color #2F497D
      &-text
        max-width 275px
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      &-highlight
        color #338FFF
        margin 0 2px
      &-gap
        height 0.5px
        // width 299px
        background #2F497D
        margin 8px -2px
        opacity 0.1
      &-rate
        color #222222
        font-weight 500
        font-size 16px
        margin-left 6px
    .pay
      color #666666
      display flex
      justify-content space-between
      font-size 12px
      align-items center
      width 100%
      &-left
        display flex
        align-items baseline
        margin-top 4px
      &-amount
        color #FF6400
        font-size 22px
        margin 0 1px 0 4px
        font-weight 500
      &-right
        display flex
        align-items center
      &-button
        display flex
        background #FF6400
        color #FFFFFF
        font-weight 500
        border-radius 50px
        margin-left 10px
        width 70px
        height 28px
        align-items center
        justify-content center
        z-index 1
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'hl-text': '@/components/hl-text'
    }
  }
</script>
